import { render, staticRenderFns } from "./view-banners.vue?vue&type=template&id=24f8314b"
import script from "./view-banners.vue?vue&type=script&lang=js"
export * from "./view-banners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports